import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ChevronDown } from "lucide-react";
export default function YourFinalApproachStrategy() {
  return <section data-section-id="233563" id="your-final-approach-strategy" className="relative flex min-h-[100svh] w-full items-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689271/img/gulfstream_cockpit_dawn_runway.png" alt="Gulfstream cockpit at dawn looking out at a distant runway" className="h-full w-full object-cover object-center opacity-40" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background/95 via-background/70 to-transparent" />
        <div className="absolute inset-0 bg-background/10 backdrop-blur-[1px]" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl space-y-8">
          {}
          <h1 className="font-default text-5xl font-bold leading-[1.05] tracking-tighter text-foreground sm:text-6xl md:text-7xl lg:text-8xl uppercase">
            Design Your
            <br />
            Final Approach.
          </h1>

          {}
          <p className="font-default text-lg leading-relaxed text-muted-foreground md:text-xl md:max-w-xl">
            Precision aging for pilots who refuse the holding pattern of a nursing home. Secure your legacy and stay close to the flight line.
          </p>

          {}
          <div className="flex flex-col gap-4 pt-4 sm:flex-row sm:items-center">
            <Button asChild size="lg" className="h-14 px-8 text-base font-bold tracking-wide bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg">
              <Link to="/FlightDeckPage">Initiate Plan</Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="h-14 border-secondary bg-transparent px-8 text-base font-bold tracking-wide text-foreground backdrop-blur-md hover:bg-secondary/20 hover:text-foreground">
              <Link to="/TheFlightPlanPage">View Mission Profile</Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 z-10 flex -translate-x-1/2 flex-col items-center opacity-70">
        <span className="mb-2 font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
          Altitude
        </span>
        <div className="h-12 w-px bg-muted-foreground/50 animate-pulse" />
      </div>
    </section>;
}